app.factory('menuService', [ '$http', function($http) {
    return {
        get : function(id) {
            return $http.get('api/menu/')
            .then(res => {
                return res.data;
            }, errorHandler)
        }
    }
} ]);
